import "@/App.css";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CurrencyProvider, useCurrency } from "@/context/CurrencyContext";
import AuthWall from "@/pages/AuthWall";
import Dashboard from "@/pages/Dashboard";
import { Loader2 } from "lucide-react";

function Gate() {
  const { user, booting } = useAuth();
  const { ready } = useCurrency();

  if (booting || user === undefined || !ready) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0D0D0D]">
        <div className="flex flex-col items-center gap-3">
          <Loader2 className="h-8 w-8 animate-spin text-[#00C896]" />
          <p className="text-slate-400 text-sm">Securing your session…</p>
        </div>
      </div>
    );
  }

  return user ? <Dashboard /> : <AuthWall />;
}

function App() {
  return (
    <div className="App">
      <div className="mm-grain" />
      <BrowserRouter>
        <AuthProvider>
          <CurrencyProvider>
            <Gate />
          </CurrencyProvider>
          <Toaster position="top-right" theme="dark" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
